"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * GlobalClick component
 *
 * A utility component that listens to global document clicks and triggers callbacks.
 * Useful for implementing dropdown/popover close-on-outside-click behavior.
 *
 * @example
 * <GlobalClick onGlobalClick={closeDropdown}>
 *   <div>Dropdown content</div>
 * </GlobalClick>
 */
var GlobalClick = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GlobalClick, _Component);

  var _super = _createSuper(GlobalClick);

  function GlobalClick() {
    var _this;

    (0, _classCallCheck2.default)(this, GlobalClick);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClick", function (e) {
      // Backward compatibility: support deprecated onGlobalClick prop
      if (_this.props.onGlobalClick) {
        _this.props.onGlobalClick(e);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(GlobalClick, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        return window.document.addEventListener('click', _this2.onClick);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.document.removeEventListener('click', this.onClick);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var WrapperComponent = props.Component || 'div';
      var WrapperEl = WrapperComponent;
      return (0, _preact.h)(WrapperEl, (0, _extends2.default)({
        onClick: function onClick(e) {
          e.stopPropagation();

          if (props.onChildrenClick && typeof props.onChildrenClick === 'function' && e.target.tagName !== 'INPUT') {
            props.onChildrenClick();
          }
        }
      }, props));
    }
  }]);
  return GlobalClick;
}(_preact.Component);

var _default = GlobalClick;
exports.default = _default;